import React, { useEffect, useState } from "react";
import { classNames } from "utils/utils";

const LeaderboardInfo = ({ icon, number, title, subtitle, symbol, type }) => {
  const [internalCount, setInternalCount] = useState(number);
  const [bounceUp, setBounceUp] = useState(false);
  const [bounceDown, setBounceDown] = useState(false);

  useEffect(() => {
    if (number > internalCount) {
      setBounceUp(true);
    } else if (number < internalCount) {
      setBounceDown(true);
    }
  }, [number]);

  const handleAnimationEnd = () => {
    setInternalCount(number);
    setBounceUp(false);
    setBounceDown(false);
  };

  return (
    <div className="flex w-full text-xs items-center px-2 mt-2 justify-center ">
      <div
        className={classNames(
          type == "success"
            ? "bg-customGreen/10"
            : type == "warning"
            ? "bg-yellow-100"
            : type == "danger"
            ? "bg-red-100"
            : "bg-gray-200",
          bounceDown ? "animate-bounceDown" : "",
          "flex w-full h-full rounded-md px-2 flex-col   py-2 pb-3 justify-center items-center"
        )}
      >
        {number && (
          <span
            className={classNames(
              bounceUp ? "animate-bounceUp" : "",
              bounceDown ? "animate-bounceDown" : "",
              "py-1 text-xl"
            )}
            onAnimationEnd={handleAnimationEnd}
          >
            {internalCount}
            {symbol && symbol}
          </span>
        )}

        {icon && (
          <div className="flex items-center justify-center w-full h-full">
            {icon}
          </div>
        )}

        <div className="flex w-full items-center justify-center max-w-xs flex-col font-light text-center">
          {title && (
            <span className={classNames(!number && "text-sm font-semibold")}>
              {title}
            </span>
          )}
          {subtitle && <span>{subtitle}</span>}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardInfo;
